import { render, staticRenderFns } from "./PegasusFareFeatures.vue?vue&type=template&id=608fdff9&scoped=true&"
import script from "./PegasusFareFeatures.vue?vue&type=script&lang=js&"
export * from "./PegasusFareFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608fdff9",
  null
  
)

export default component.exports